import { FieldType } from '@/manual-review/form';

import validate from '@/manual-review/validations';
import {
  Document,
} from './types';

const idRegexp = /^[0-9]{9}$/;

export function validateDocumentNumber(value: string): string | boolean {
  if (!idRegexp.test(value)) {
    return 'Digite un id válido de 9 dígitos';
  }

  return true;
}

const doc: Document = {
  sides: {
    front: {
      fields: [
        {
          type: FieldType.Text,
          name: 'document_number',
          label: 'Número de cédula',
          rules: [validate.isRequired, validateDocumentNumber],
          value: '',
        },
        {
          type: FieldType.Text,
          name: 'name',
          label: 'Nombre',
          rules: [validate.isRequired, validate.name],
          value: '',
        },
        {
          type: FieldType.Text,
          name: 'last_name',
          label: '1º y 2º Apellido',
          rules: [validate.isRequired, validate.name],
          value: '',
        },
      ],
    },
    reverse: {
      fields: [
        {
          type: FieldType.Text,
          name: 'document_number',
          label: 'Número de cédula',
          rules: [validate.isRequired, validateDocumentNumber],
          value: '',
        },
        {
          type: FieldType.Date,
          name: 'date_of_birth',
          label: 'Fecha de nacimiento',
          rules: [validate.isRequired, validate.isDate, validate.dateOfBirth],
          allowedDates: validate.dateOfBirth,
          value: '',
        },
        {
          type: FieldType.Text,
          name: 'birth_place',
          label: 'Lugar de nacimiento',
          rules: [validate.isRequired, validate.place],
          value: '',
        },
        {
          type: FieldType.Text,
          name: 'residence_address',
          label: 'Domicilio electoral',
          rules: [validate.isRequired, validate.place],
          value: '',
        },
        {
          type: FieldType.Date,
          name: 'expiration_date',
          label: 'Vencimiento',
          rules: [validate.isRequired, validate.isDate, validate.dateOfExpiration],
          allowedDates: validate.dateOfExpiration,
          value: '',
        },
        {
          type: FieldType.Select,
          name: 'gender',
          label: 'Sexo',
          rules: [validate.isRequired],
          value: '',
          options: [
            { label: 'M', value: 'male' },
            { label: 'F', value: 'female' },
          ],
        },
      ],
    },
  },
};

export default doc;
